"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=callbacks.interface.js.map